forms-search-form
  form.form.row(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    .col-12.col-md-6
      inputs-search-radio-order(tag-scope="{ this.tagScope }.inputs.order")
    .col-12.col-md-6
      inputs-search-daterange(tag-scope="{ this.tagScope }.inputs.deadlinerange")
    .col-12.col-md-6
      inputs-textfield(tag-scope="{ this.tagScope }.inputs.keyword")
    .col-12.col-md-6
      inputs-search-checkbox(tag-scope="{ this.tagScope }.inputs.status")
    .col-12.col-md-6
      inputs-search-checkbox(tag-scope="{ this.tagScope }.inputs.order_type")
    .col-12.col-md-6
      inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.client_id")
    .col-12.col-md-6
      inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.user_id")
    .col-12.col-md-6
      inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.product_id")
    .col-12.col-md-6
      inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.responsible_id")
    .col-12.col-md-6
      inputs-typeahead-single(tag-scope="{ this.tagScope }.inputs.material_id")
    .col-12.col-md-6
      inputs-search-checkbox(tag-scope="{ this.tagScope }.inputs.stage")
    .col-12.col-md-6
      inputs-search-switch(tag-scope="{ this.tagScope }.inputs.pending")
    .col-12.col-md-8
      inputs-search-select-phase(tag-scope="{ this.tagScope }.inputs.phase_id")
    .col-12.col-md-4.text-right
      inputs-search-submit(tag-scope="{ this.tagScope }.inputs.submit")
  script(type="typescript").
    this.mixin('base')
